import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ExpandableCallout from '../../../components/playbooks/ExpandableCallout';

const SettingBoundariesStage3 = () => (
  <div className="space-y-8">
    <PlaybookSection title="Stage 3: Analyse and course-correct" icon={<ChartBarIcon className="h-7 w-7 text-primary-light" />} heading>
      {/* TL;DR */}
      <PlaybookCard>
        <h2 className="text-xl font-semibold mb-2">TL;DR</h2>
        <ExpandableCallout type="info" title="What do I need to DO in this stage?" defaultOpen>
          <p>You need to do 1 thing:</p>
          <ol className="list-decimal pl-6">
            <li>Check in on your team's WILO + make adjustments/support where you need to</li>
          </ol>
          <p>Here's what we mean…</p>
        </ExpandableCallout>
      </PlaybookCard>

      {/* WILO Check in */}
      <PlaybookCard>
        <h3 className="text-lg font-semibold mb-2">Action: Week in the life Of (WILO) Check in</h3>
        <p className="mb-4">When you are having 1-2-1s with your team members moving forwards it's a good idea to check in with them:</p>
        <blockquote className="border-l-4 border-primary pl-4 italic text-gray-300 mb-4">
          Are they able to focus on the agreed activity buckets?<br />
          Are we spending time where we need to be?<br />
          What challenges are cropping up in trying to do so?
        </blockquote>
        <p className="mb-4">These questions help you understand whether they are able to manage the boundaries that you as a team have collectively committed to. It gives you signal on whether there are any particular teams/individuals outside of your own team who are overstepping.</p>
        <p className="mb-4">Sometimes this will require you to personally follow up and help that team/individual understand the impact of their behaviour..</p>
        <p className="mb-4">It's also a good idea to use this conversation for an opportunity to understand people's individual work preferences and see how they are lining up against the kind of work being asked of them. These questions help:</p>
        <blockquote className="border-l-4 border-primary pl-4 italic text-gray-300 mb-4">
          What's the most important thing you're focusing on right now?<br />
          What problems are you facing?<br />
          What do you need that you don't currently have to achieve success?<br />
          When do you do your best work?<br />
          When are you able to find flow?
        </blockquote>
        <p className="mb-4">It's sometimes helpful to work with folks on their calendar. Firing up google calendar and looking back at the last few weeks to map that against focus areas. This can feel micro-managery if not done with skill but the goal is to basically help someone prioritise and make sure you are giving them enough support to be effective.</p>
      </PlaybookCard>

      {/* Recap */}
      <PlaybookCard>
        <h3 className="text-lg font-semibold mb-2">Recap</h3>
        <ul className="list-disc pl-6">
          <li>Put in place space in your 1-2-1 cadence to check in with team members on how they are finding upholding the commitments you made as a team, giving you signal on whether they need any extra support here</li>
        </ul>
      </PlaybookCard>
    </PlaybookSection>
  </div>
);

export default SettingBoundariesStage3; 